/**
 * @classdesc Polish Language Pack
 * @desc This class will used to translate tokens into the Polish language.
 * @namespace Languages.Polish
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Polish
 */
export const dictionary = {
	'years'   : 'Lat',
	'months'  : 'Miesięcy',
	'days'    : 'Dni',
	'hours'   : 'Godziny',
	'minutes' : 'Minuty',
	'seconds' : 'Sekundy'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Polish
 */
export const aliases = ['pl', 'pl-pl', 'polish'];
